<div class="attendance-dashboard-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon>schedule</mat-icon>
        Today's Attendance Dashboard
      </mat-card-title>
      <mat-card-subtitle>{{ today | date:'EEEE, MMMM d, yyyy' }}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <!-- Actions Section - All Users -->
      <div class="actions-section">
        <button mat-raised-button color="primary" (click)="goToClockInOut()" class="clock-btn">
          <mat-icon>add</mat-icon>
          Clock In/Out
        </button>
        <button mat-stroked-button (click)="refreshData()" [disabled]="loading" class="refresh-btn">
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
      </div>

      <!-- Search Filter -->
      <div class="search-section">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search Entries</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search by employee name" #input>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- Loading Spinner -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading today's attendance...</p>
      </div>

      <!-- Attendance Table -->
      <div class="table-container mat-elevation-z8" *ngIf="!loading && dataSource.data.length > 0">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <!-- Employee Name Column -->
          <ng-container matColumnDef="employeeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Employee</th>
            <td mat-cell *matCellDef="let row">
              <div class="employee-name-cell">
                <span class="employee-name">{{ row.employeeName }}</span>
                <mat-icon *ngIf="row.faceMatchFlagged" 
                         class="face-verification-warning" 
                         matTooltip="Face verification failed">
                  warning
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <!-- Timestamp Column -->
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Time</th>
            <td mat-cell *matCellDef="let row">{{ row.timestamp | date:'shortTime' }}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge" [ngClass]="getStatusClass(row.status)">
                {{ getStatusLabel(row.status) }}
              </span>
            </td>
          </ng-container>

          <!-- Photo Column -->
          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef>Photo</th>
            <td mat-cell *matCellDef="let row">
              <div class="photo-cell">
                <img *ngIf="row.photo" 
                     [src]="row.photo" 
                     alt="Attendance Photo" 
                     class="attendance-photo">
                <div *ngIf="!row.photo" class="no-photo">
                  <mat-icon>photo</mat-icon>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Face Verification Column -->
          <ng-container matColumnDef="faceVerification">
            <th mat-header-cell *matHeaderCellDef>Face Verification</th>
            <td mat-cell *matCellDef="let row">
              <div class="face-verification-status">
                <mat-icon *ngIf="row.faceMatchFlagged" 
                         class="face-verification-failed" 
                         matTooltip="Face verification failed">
                  warning
                </mat-icon>
                <mat-icon *ngIf="!row.faceMatchFlagged" 
                         class="face-verification-passed" 
                         matTooltip="Face verification passed">
                  check_circle
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
              [ngClass]="{ 'face-verification-flagged': row.faceMatchFlagged }"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of attendance entries"></mat-paginator>
      </div>

      <!-- No Data Message -->
      <div *ngIf="!loading && dataSource.data.length === 0" class="no-data-container">
        <mat-icon>schedule</mat-icon>
        <h3>No attendance entries for today</h3>
        <p>No employees have clocked in or out today.</p>
        <button mat-raised-button color="primary" (click)="goToClockInOut()" class="first-entry-btn">
          <mat-icon>add</mat-icon>
          Make First Entry
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div> 